import type { TrpcProxyClient } from '../../trpc';
import type { BlockDomain } from '@strength/domain';

export const sendTransaction_BlockAsync = async (
  trpc: TrpcProxyClient,
  args: BlockDomain.Command,
): Promise<{ lastSyncId: number }> => {
  switch (args.type) {
    case 'Create':
      return trpc.block.createBlock.mutate(args.input);
    case 'Copy':
      return trpc.block.copyBlock.mutate(args.input);
    case 'Edit':
      return trpc.block.editBlock.mutate(args.input);
    case 'Delete':
      return trpc.block.deleteBlock.mutate(args.input);
    case 'Cancel':
      return trpc.block.cancelBlock.mutate(args.input);

    default:
      const _: never = args;
      throw new Error(`Unknown args type: ${(args as any).type}`);
  }
};
